import React from 'react';
import MerchantVisibilityComp from '../../components/Fundraiser/MerchantVisibility';

const MerchantVisibility = () => {
    return (
        <MerchantVisibilityComp />
    )
}

export default MerchantVisibility;
